// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum AccreditationsByAccountStatus {
	Pending = 1,
	FileDownloaded = 2,
	Completed = 3,
	Cancelled = 4,
}
